module.exports = __webpack_public_path__ + "img/cunzheng_2.60ca191a.png";